module.exports = "query ($reference: ID!) {\n  ResidentialTemplate(id: $reference) {\n    id\n    name\n  }\n}\n"